/**
 * Cordova is ready and initiated
 */
export const CORDOVA_READY = 'CORDOVA_READY';
export const CORDOVA_SET_VERSION = 'CORDOVA_SET_VERSION';
export const CORDOVA_SET_DEVICE_INFO = 'CORDOVA_SET_DEVICE_INFO';

export default {
  CORDOVA_READY,
  CORDOVA_SET_VERSION,
  CORDOVA_SET_DEVICE_INFO,
};



// WEBPACK FOOTER //
// ./src/apps/cordova/store/types.js